import { SpoUserSettingsResponse } from '@spo/types';

export const buildUrlFromUserConfiguration = (
  config: SpoUserSettingsResponse,
  urlBase: string,
) => {
  const params = new URLSearchParams();
  if (config.sportIds) {
    params.set('sports', config.sportIds.toString());
  }
  if (config.productNatureIds) {
    params.append('productNatures', config.productNatureIds?.toString());
  }
  if (config.retailFamilyIds) {
    params.append('retailFamilies', config.retailFamilyIds?.toString());
  }
  if (config.offerDate) {
    params.append('offerDate', config.offerDate);
  }

  return `${urlBase}?${params.toString()}`;
};
